import { render, staticRenderFns } from "./BusinessesList.vue?vue&type=template&id=dd3e5a14&scoped=true&"
import script from "./BusinessesList.vue?vue&type=script&lang=ts&"
export * from "./BusinessesList.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessesList.vue?vue&type=style&index=0&id=dd3e5a14&lang=sass&scoped=true&"
import style1 from "./BusinessesList.vue?vue&type=style&index=1&id=dd3e5a14&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3e5a14",
  null
  
)

export default component.exports